module.exports = __webpack_public_path__ + "static/media/C-sharp-Triads.605e6cb3.png";